<template>
  <v-container>
    <v-form ref="form" v-model="validado">
      <v-row dense>
        <v-col cols="12">
          <div class="text-h6">Consulta de la siembra</div>
        </v-col>
        <v-col cols="12">
          <v-text-field
            readonly
            :value="estadito"
            label="Estatus"
            outlined
            disabled
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            readonly
            :value="getNombreDeFincas(siembra.ID_FINCA)"
            label="Finca*"
            outlined
          >
          </v-text-field>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="siembra.ID_ESTABLECIMIENTO"
            :items="establecimientosPorId(siembra.ID_FINCA)"
            readonly
            item-value="id"
            item-text="rua"
            label="RUA"
            outlined
          ></v-select>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="getNombreDeParcela(siembra.ID_PARCELA)"
            label="Parcela"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="siembra.COA"
            label="Número de COA*"
            outlined
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="cultivoPorId(siembra.ID_CULTIVO)"
            label="Rubro*"
            outlined
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="siembra.VARIEDAD"
            label="Variedad"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="siembra.SEMILLA"
            label="Tipo de semilla"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="siembra.DENOMINACION_VARIETAL"
            label="Denominación varietal"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="siembra.FECHA_SIEMBRA"
            label="Fecha de la siembra*"
          ></v-text-field>
        </v-col>
        <!-- año agricola -->
        <v-col cols="6">
          <v-text-field
            readonly
            :value="siembra.ANIO_AGRICOLA"
            label="inserte el año agricola"
          >
          </v-text-field>
          <!-- <v-date-picker-years
            v-model="siembra.ANIO_AGRICOLA"
            label="año agricola"
            :min="siembra.ANIO_AGRICOLA - 1"
            :max="siembra.FECHA_SIEMBRA"
          ></v-date-picker-years> -->
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="siembra.ley_de_beneficio"
            label="Ley de beneficio"
            outlined
          />
        </v-col>
        <v-col cols="8" md="6">
          <v-text-field
            readonly
            :value="siembra.CANTIDAD_SEMILLA"
            label="Cantidad de semilla*"
            outlined
          >
            <template v-slot:append>
              <unit-picker @transform="siembra.CANTIDAD_SEMILLA = $event" />
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="8" md="6">
          <v-text-field
            readonly
            :value="siembra.VOLUMEN_ANUAL_PRODUCCION"
            label="Producción estimada*"
            outlined
          >
            <template v-slot:append>
              <unit-picker
                @transform="siembra.VOLUMEN_ANUAL_PRODUCCION = $event"
              />
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="siembra.SUPERFICIE_ACTUAL_SEMBRADA"
            label="Superficie sembrada*"
            suffix="Ha"
            outlined
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="siembra.SUPERFICIE_ADICIONAL_PROYECTADA"
            label="Superficie adicional proyectada*"
            suffix="Ha"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="siembra.FECHA_ESTIMADA_COSECHA"
            label="Fecha estimada de cosecha*"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="primaestatal"
            label="Prima de seguro estatal*"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="primasp"
            label="Prima de seguro privado*"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="festatal"
            label="Financiamiento estatal*"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="fcoop"
            label="Financiamiento cooperativa*"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="autofi"
            label="Auto financiamiento*"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="otrofi"
            label="Otro tipo de financiamiento"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="traza"
            label="Realiza control de trazabilidad*"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="provinciaPorId(siembra.ID_PROVINCIA)"
            label="Provincia*"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="distritoPorId(siembra.ID_DISTRITO)"
            label="Distrito*"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="corregimientoPorId(siembra.ID_CORREGIMIENTO)"
            label="Corregimiento*"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="pobladoPorId(siembra.ID_POBLADO)"
            label="Poblado*"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            readonly
            :value="siembra.tecnologias"
            label="Tecnologías*"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <div class="text-h6">Ubicación (WGS84)</div>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="siembra.LONGITUD"
            label="Longitud"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            readonly
            :value="siembra.LATITUD"
            label="Latitud"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <div class="text-h6">Observaciones</div>
        </v-col>
        <v-col cols="12">
          <v-text-field
            readonly
            :value="siembra.observacion"
            label="Observaciones"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <registro-existente
      :title="'La siembra ya existe'"
      :description="'Los datos colocados corresponden a una siembra existente, desea cargar la información de esta siembra?'"
      :loading="modal_registro_existe_loading"
      :modal="modal_registro_existe"
      @cerrarModal="cerrarModalRegistroExistente"
      @cargarDatos="cargarRegistroExistente"
    />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import debounce from 'lodash.debounce'
//import FincaSelectItem from '../../components/FincaSelectItem.vue'
import {
  toArray,
  getCurrentPosition,
  clona,
  elObjetoTienePropiedades,
  isProductionDateValidComparedToRecords,
} from '@/utilidades'
import { formulario_siembra } from '@/modelos'
import * as rules from '@/utils/validations'
//import ModalParcela from '@/components/ModalParcela.vue'
//import ModalEstablecimiento from '@/components/ModalEstablecimiento.vue'

export default {
  name: 'Cosiembra',
  components: {
    //ModalParcela,
    //ModalEstablecimiento,
  },
  data: () => {
    return {
      estadito: '',
      r: rules,
      validado: false,
      modal_registro_existe: false,
      modal_registro_existe_loading: false,
      registro_existente: {},
      siembra: clona(formulario_siembra),
      alertar_superficie_mayor: '',
      loading: false,
      primaestatal: '',
      primasp: '',
      festatal: '',
      fcoop: '',
      autofi: '',
      otrofi: '',
      traza: '',
    }
  },
  computed: {
    ...mapState('listados', [
      'cultivo',
      'variedad_cultivo',
      'semilla',
      'denominacion_varietal',
      'sino',
      'tecnologia',
      'peso',
      'peso_default',
      'lb_to_kg',
      'estatus',
      'programa_gobierno',
    ]),
    ...mapGetters('listados', [
      'denominacionVarietalDeCultivo',
      'cultivoPorId',
      'provinciaPorId',
      'distritoPorId',
      'corregimientoPorId',
      'pobladoPorId',
    ]),
    ...mapGetters('registros', [
      'existeRegistroEnState',
      'establecimientosPorId',
      'parcelasPorId',
      'getSumaDeExtensionEnSiembras',
      'finca',
      'getMatchingRecords',
      'getNombreDeParcela',
      'getNombreDeFincas',
    ]),
    // retorna cierto si existe al menos una tecnología en el arreglo de tecnologías usadas en la siembra
    puedeRemoverTecnologia() {
      return this.siembra.tecnologias.length >= 2
    },
    fincas() {
      return toArray(this.$store.state.registros.fincasc)
    },
    sumaDeSuperficiesDeSiembras() {
      return parseInt(
        this.getSumaDeExtensionEnSiembras(
          this.siembra.ID,
          this.siembra.ID_FINCA,
          this.siembra.COA,
          new Date(this.siembra.FECHA_SIEMBRA).getFullYear()
        )
      )
    },
    invalidRelativeDate() {
      const preparacion =
        this.getMatchingRecords({
          recordName: 'preparacionesc',
          matchValues: [
            { key: 'id_productor', value: this.siembra.id_productor },
            { key: 'coa', value: this.siembra.COA },
            { key: 'id_finca', value: this.siembra.ID_FINCA },
            { key: 'id_parcela', value: this.siembra.ID_PARCELA },
            { key: 'id_cultivo', value: this.siembra.ID_CULTIVO },
          ],
        })?.[0] ?? {}
      const cosecha =
        this.getMatchingRecords({
          recordName: 'cosechasc',
          matchValues: [
            { key: 'id_productor', value: this.siembra.id_productor },
            { key: 'coa', value: this.siembra.COA },
            { key: 'id_finca', value: this.siembra.ID_FINCA },
            { key: 'id_parcela', value: this.siembra.ID_PARCELA },
            { key: 'id_cultivo', value: this.siembra.ID_CULTIVO },
          ],
        })?.[0] ?? {}

      const referenceRecord = {
        record: 'siembra',
        date: this.siembra.FECHA_SIEMBRA,
      }
      const compareRecords = [
        { record: 'preparacion', date: preparacion.fecha, cp: 'isAfter' },
        { record: 'cosecha', date: cosecha.fecha, cp: 'isBefore' },
      ].filter((v) => !!v)
      return isProductionDateValidComparedToRecords(
        referenceRecord,
        compareRecords
      )
    },
    validHarvestRelativeDate() {
      const siembra = new Date(this.siembra.FECHA_SIEMBRA).getTime()
      const estimada = new Date(this.siembra.FECHA_ESTIMADA_COSECHA).getTime()

      return estimada > siembra
    },
  },
  watch: {
    '$route.params.id'() {
      this.cargarRegistro(this.obtenerIdDeRuta())
    },
    'siembra.estatus'() {
      if (this.siembra.estatus === 'A') {
        this.estadito = 'Actualizado'
      } else {
        this.estadito = 'Desactualizado'
      }
    },
    'siembra.SUPERFICIE_ACTUAL_SEMBRADA'() {
      this.alertSurfaceOverflow()
    },
    'siembra.ID_PROVINCIA'(newVal, oldVal) {
      if (!!oldVal && newVal !== oldVal) {
        this.siembra.ID_DISTRITO = ''
        this.siembra.ID_CORREGIMIENTO = ''
        this.siembra.ID_POBLADO = ''
      }
    },
    'siembra.ID_DISTRITO'(newVal, oldVal) {
      if (!!oldVal && newVal !== oldVal) {
        this.siembra.ID_CORREGIMIENTO = ''
        this.siembra.ID_POBLADO = ''
      }
    },
    'siembra.ID_CORREGIMIENTO'(newVal, oldVal) {
      if (!!oldVal && newVal !== oldVal) {
        this.siembra.ID_POBLADO = ''
      }
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Consulta Siembra')
    const id = this.obtenerIdDeRuta()
    if (id) {
      this.cargarRegistro(id)
    } else {
      this.siembra = clona(formulario_siembra)
    }
  },
  methods: {
    alertSurfaceOverflow() {
      this.alertar_superficie_mayor = ''
      if (this.siembra.ID_FINCA) {
        this.alertar_superficie_mayor =
          this.sumaDeSuperficiesDeSiembras +
            parseInt(this.siembra.SUPERFICIE_ACTUAL_SEMBRADA) >
          this.finca(this.siembra.ID_FINCA)?.extension
            ? 'La suma de las superficies sembradas para este año, coa y finca exceden la superficie de la finca'
            : ''
      }
    },
    // obtiene la posición y la carga a los campos [x, y] del formulario
    async obtenerPosicion() {
      const position = await getCurrentPosition()
      if (position) {
        this.siembra.LONGITUD = position.coords.longitude
        this.siembra.LATITUD = position.coords.latitude
      }
    },
    async cargarRegistroExistente() {
      const id = this.registro_existente.ID
      this.modal_registro_existe_loading = true
      if (!this.existeRegistroEnState('siembrasc', id)) {
        await this.cargarRegistroDelServer(this.registro_existente)
      }
      this.$router.push(`/ru/cocultivo/${id}`)
      this.cerrarModalRegistroExistente()
      this.modal_registro_existe_loading = false
    },
    cargarRegistro(id) {
      if (this.existeRegistroEnState('siembrasc', id)) {
        this.siembra = this.obtenerRegistroDelState(id)
        this.$refs.form.resetValidation()
        if (this.siembra.PRIMA_SEGURO_ESTATAL === 0) {
          this.primaestatal = 'NO'
        } else {
          this.primaestatal = 'SI'
        }
        if (this.siembra.PRIMA_SEGURO_PRIVADO === 0) {
          this.primasp = 'NO'
        } else {
          this.primasp = 'SI'
        }
        if (this.siembra.FINANCIAMIENTO_ESTATAL === 0) {
          this.festatal = 'NO'
        } else {
          this.festatal = 'SI'
        }
        if (this.siembra.FINANCIAMIENTO_COOPERATIVA === 0) {
          this.fcoop = 'NO'
        } else {
          this.fcoop = 'SI'
        }
        if (this.siembra.AUTO_FINANCIAMIENTO === 0) {
          this.autofi = 'NO'
        } else {
          this.autofi = 'SI'
        }
        if (this.siembra.OTRO_TIPO_FINANCIAMIENTO === 0) {
          this.otrofi = 'NO'
        } else {
          this.otrofi = 'SI'
        }
        if (this.siembra.REALIZA_TRAZABILIDAD === 0) {
          this.traza = 'NO'
        } else {
          this.traza = 'SI'
        }
        return true
      } else return false
    },
    async buscarRegistroExistente() {
      const registro = await this.obtenerUnRegistroONada()
      if (elObjetoTienePropiedades(registro)) {
        const id = registro.ID ? registro.ID.toString() : ''
        if (id === this.obtenerIdDeRuta()) return false
        this.almacenarRegistroEncontradoTemporalmente(registro)
        this.mostrarModalDeRegistroExistente()
        return true
      }
      return false
    },
    debounceBuscarRegistroExistente: debounce(async function () {
      await this.buscarRegistroExistente()
    }, 1500),
    async obtenerUnRegistroONada() {
      try {
        const id_productor = this.siembra.id_productor
        const coa = this.siembra.COA
        const fecha = this.siembra.FECHA_SIEMBRA
        const id_finca = this.siembra.ID_FINCA
        const id_parcela = this.siembra.ID_PARCELA
        const id_cultivo = this.siembra.ID_CULTIVO
        // required fields to be fulfilled
        if (coa && fecha && id_finca && id_cultivo) {
          const { status, data } = await this.$store.dispatch(
            'registros/listarSiembras',
            {
              id_productor,
              coa,
              fecha,
              id_finca,
              id_cultivo,
              id_parcela,
            }
          )
          if (status === 'ok' && data.length > 1) return data[0]
        }
        return {}
      } catch (e) {
        return {}
      }
    },
    async cargarRegistroDelServer(registro) {
      try {
        // especial case
        registro.id = registro.ID
        await this.$store.dispatch('registros/getSiembras', registro)
        return true
      } catch (e) {
        return false
      }
    },
    mostrarModalDeRegistroExistente() {
      this.modal_registro_existe = true
    },
    cerrarModalRegistroExistente() {
      this.modal_registro_existe = false
    },
    almacenarRegistroEncontradoTemporalmente(registro) {
      this.registro_existente = registro
    },
    obtenerRegistroDelState(id) {
      return {
        ...formulario_siembra,
        ...this.$store.state.registros.siembrasc[id],
      }
    },
    obtenerIdDeRuta() {
      return this.$route.params.id || ''
    },
  },
}
</script>
